import { render, staticRenderFns } from "./relevanceOrg.vue?vue&type=template&id=04b3e112"
import script from "./relevanceOrg.vue?vue&type=script&lang=js"
export * from "./relevanceOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports